import configureLogger from "@asosteam/asos-web-logging";

const logger = configureLogger({
  moduleName: "asos-web-customer-care",
  maxLogLevel: "info",
});

export default logger;
